import enMessages from "./en";
import svMessages from "./sv";

export const en = enMessages;
export const sv = svMessages;



// WEBPACK FOOTER //
// ./src/i18n/index.js